    <!-- Body -->
    <div *ngFor="let event of events | keyvalue : originalOrder; let i = index">
        <div>
            <a class="swapa-accordion-postfix text-body h4 py-1"
               href="#accordion-{{event.key}}"
               data-toggle="collapse"
               attr.aria-expanded="{{(i == 0 ? true : false)}}">
                {{event.key}}
            </a>
            <div id="accordion-{{event.key}}" class="row collapse {{(i == 0 ? 'show' : '')}}">
                <div class="col-12 col-sm-6 col-md-4 col-lg-3 py-3" *ngFor="let album of events.get(event.key)">
                    <a class="text-dark" href={{album.EventPageLink}}>
                        <img class="cover w-100"
                             height="160"
                             [src]="album.CoverImage"
                             alt="" />
                        <h3 class="text-link pt-2 mb-0">{{album.AlbumTitle}}</h3>
                        <span>{{album.EventDate}}</span>
                    </a>
                </div>
            </div>
        </div>              
    </div>
    <div class="row pt-3">
        <div class="col-md-12 p-3">
            <ngx-spinner bdOpacity=0.9
                         bdColor=""
                         size="default"
                         color="#581f87"
                         type="ball-pulse-sync"
                         [fullScreen]="false">
            </ngx-spinner>
        </div>
    </div>

